const initialState = {
  allUsers: [],
  gameConfig: null,
  // Accounts seen in the last hour (GET /online/); null until the first answer.
  population: null,
}

export default initialState
